import React from "react";
import { Link } from "gatsby";
import ReactWOW from "react-wow";

import aboutImage from "../../static/images/about/about-img5.png";
import icon4 from "../../static/images/icons/icon4.png";
import icon5 from "../../static/images/icons/icon5.png";
import icon6 from "../../static/images/icons/icon6.png";
import icon7 from "../../static/images/icons/icon7.png";

const features = [
  {
    icon: icon4,
    title: "Microsoft Cloud Transformation",
    text: "We help organisations plan, implement, migrate, optimise, secure, and govern Microsoft 365 and Azure environments that can support growth.",
    alt: "Operational risk reduction icon",
  },

  {
    icon: icon5,
    title: "Digital Workplace Enablement",
    text: "We support SharePoint, Teams, OneDrive, document management, collaboration, workflow automation, and practical productivity improvements.",
    alt: "Security and compliance alignment icon",
  },

  {
    icon: icon6,
    title: "Security, Identity and Governance",
    text: "We strengthen identity, access, MFA, Conditional Access, Defender, data protection, governance, and compliance-aligned controls.",
    alt: "Identity governance icon",
  },

  {
    icon: icon7,
    title: "Plain-English Business Guidance",
    text: "We give owners, principals, managers, and compliance stakeholders clear priorities instead of overwhelming them with technical noise.",
    alt: "Trusted IT support icon",
  },
];

const AboutUsContent = () => {
  return (
    <section className="about-area modern-about-area ptb-100">
      <div className="container">

        <div className="row align-items-center g-4">

          {/* ================= Left Content ================= */}

          <div className="col-lg-6 col-md-12 order-2 order-lg-1">

            <ReactWOW animation="fadeInLeft" delay=".2s">

              <div className="about-content">

                <span className="about-badge">
                  Microsoft Cloud Transformation & Trusted Technology Advisor
                </span>

                <h2>
                  Helping Microsoft-Dependent Organisations Modernise, Secure and Grow
                </h2>

                <p className="about-lead">
                  CloudLogic IT Solutions exists for organisations that rely on
                  Microsoft technologies and want to modernise operations,
                  improve collaboration, reduce risk, strengthen governance,
                  and prepare for future growth.
                </p>

                <p>
                  We help business owners, schools, healthcare providers,
                  professional services firms, financial services organisations,
                  and compliance-driven teams implement, optimise, secure, and
                  govern Microsoft 365, Azure, SharePoint, Teams, OneDrive,
                  automation, identity, and compliance-aligned controls.
                </p>

                <p>
                  Our approach is practical: understand the business need,
                  design the right Microsoft cloud roadmap, implement the
                  solution, secure and govern it properly, and support ongoing
                  improvement as the organisation grows.
                </p>

                {/* ================= Feature Grid ================= */}

                <div className="features-grid">

                  {features.map((item, index) => (
                    <div className="feature-card" key={index}>

                      <div className="feature-icon">
                        <img src={item.icon} alt={item.alt} />
                      </div>

                      <div className="feature-text">
                        <h3>{item.title}</h3>
                        <p>{item.text}</p>
                      </div>

                    </div>
                  ))}

                </div>

                {/* ================= Highlight Tags ================= */}

                <div className="about-highlight">
                  <span>Microsoft 365 & Azure Security</span>
                  <span>SharePoint, Teams & Automation</span>
                  <span>Governance & Compliance Readiness</span>
                </div>

                {/* ================= CTA ================= */}

                <div className="about-btns">

                  <Link to="/contact" className="default-btn">
                    Book Microsoft 365 Health Check
                  </Link>

                  <Link to="/services" className="optional-btn">
                    Explore Services
                  </Link>

                </div>

              </div>

            </ReactWOW>

          </div>

          {/* ================= Right Image ================= */}

          <div className="col-lg-6 col-md-12 order-1 order-lg-2">

            <ReactWOW animation="fadeInRight" delay=".3s">

              <div className="about-image-wrap">

                <div className="about-image-shape shape-one"></div>
                <div className="about-image-shape shape-two"></div>

                <div className="about-image-card">

                  <img
                    src={aboutImage}
                    alt="Microsoft cloud governance security and compliance support"
                  />

                </div>

                <div className="about-floating-card">

                  <strong>
                    Microsoft Cloud Growth Partner
                  </strong>

                  <span>
                    Helping organisations modernise, collaborate, secure, govern, and scale
                  </span>

                </div>

              </div>

            </ReactWOW>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutUsContent;
